// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedKeratoconus_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1178 21.9998C17.9258 21.9998 21.9999 17.7228 21.9999 11.9999C21.9999 6.27699 17.9258 1.99998 13.1178 1.99998C10.4564 1.99998 8.60507 3.14921 7.0024 4.92634C5.76521 6.2982 4.80239 7.87859 3.77809 9.55989C3.37528 10.2211 2.96295 10.8979 2.52069 11.5837C2.00637 12.3813 1.97396 12.8748 2.01094 13.1644C2.05331 13.4965 2.23029 13.8872 2.64589 14.3925C3.02278 14.8507 3.47376 15.2651 4.00939 15.7572C4.08895 15.8303 4.17038 15.9052 4.25371 15.9821L4.26807 15.9953C4.75882 16.4484 5.48961 17.123 5.94172 17.9239C7.28161 19.7109 8.40195 20.6821 9.44111 21.2321C10.4789 21.7813 11.6038 21.9998 13.1178 21.9998ZM4.24929 18.9998C3.96994 18.4351 3.34849 17.8651 2.66479 17.2381C0.92725 15.6446 -1.21229 13.6824 0.839856 10.4999C1.21928 9.91148 1.5952 9.29437 1.97766 8.66653C4.47773 4.56246 7.25702 0 13.1178 0C19.2204 0 23.9999 5.37253 23.9999 11.9999C23.9999 18.6272 19.2204 23.9998 13.1178 23.9998C9.68071 23.9998 7.21189 22.9998 4.24929 18.9998Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49999 15.9232C8.79575 14.9366 8.99998 13.5684 8.99998 11.9999C8.99998 10.4314 8.79575 9.06311 8.49998 8.0766C8.20422 9.06311 7.99999 10.4314 7.99999 11.9999C7.99999 13.5684 8.20422 14.9366 8.49999 15.9232ZM8.49998 18.9998C9.88068 18.9998 11 15.8658 11 11.9999C11 8.13392 9.88068 4.99995 8.49998 4.99995C7.11929 4.99995 6.00001 8.13392 6.00001 11.9999C6.00001 15.8658 7.11929 18.9998 8.49998 18.9998Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedKeratoconus is a generated icon component.
 */
let IconMedKeratoconus = IconMedKeratoconus_1 = class IconMedKeratoconus extends IconBaseElement {
    render() {
        return html `${IconMedKeratoconus_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedKeratoconus.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedKeratoconus = IconMedKeratoconus_1 = __decorate([
    customElement('zui-icon-med-keratoconus')
], IconMedKeratoconus);
export { IconMedKeratoconus };
